import classNames from "classnames";

import CasesTableCell from "./TableCell";

type ReactTableRowProps = {
  row: any;
  canExpand?: boolean;
  isLastCaseViewed?: boolean;
  isUnviewed?: boolean;
};

const CasesTableRow = ({
  row,
  canExpand,
  isLastCaseViewed,
  isUnviewed,
}: ReactTableRowProps) => {
  const handleOnClick = () => {
    row.toggleRowExpanded();
  };

  return (
    <tr
      {...row.getRowProps()}
      className={classNames("table__row", {
        expanded: row.isExpanded,
        "ViewerListTable__row--lastViewed": isLastCaseViewed,
        "ViewerListTable__row--unviewed": isUnviewed,
        "ViewerListTable__row--viewed": !isUnviewed,
      })}
      onClick={canExpand ? handleOnClick : undefined}
    >
      {row.cells.map((cell: any) => {
        return (
          <CasesTableCell
            cell={cell}
            isCellExpanded={row.isExpanded}
            key={`row:${cell.row.id}--col:${cell.column.id}`}
          />
        );
      })}
    </tr>
  );
};

export default CasesTableRow;
